import { useRef } from 'react';
import classNames from 'classnames';
import styles from './range-input.module.scss';

const countDecimals = (num) => {
  if (Math.floor(num) === num) return 0;
  return num.toString().split('.')[1].length || 0;
};

const normalizeInput = (val, step, min, max) => {
  const numVal = Number(val);
  if (Number.isNaN(numVal)) {
    return null;
  }
  let normVal = Math.round(numVal / step) * step;
  normVal = Number(normVal.toFixed(countDecimals(step)));
  normVal = Math.max(min, normVal);
  normVal = Math.min(max, normVal);
  return normVal;
};

const RangeInput = ({
  label = '',
  min = 0,
  max = 100,
  step = 1,
  value = 50,
  onChange = () => {},
  className = '',
  containerClassName = '',
  id = '',
  editable = false,
  unit = '',
  unitSide = 'right',
}) => {
  const inputRef = useRef();

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      inputRef.current.blur();
    }
  };

  const handleBlur = () => {
    const newVal = normalizeInput(inputRef.current.value, step, min, max);
    if (newVal || newVal === 0) {
      onChange(newVal);
    }
  };

  return (
    <article
      className={classNames(styles.rangeInputContainer, containerClassName)}
    >
      {label && (
        <label className={styles.sliderLabelContainer} htmlFor={id}>
          <span className={styles.sliderLabel}>{label}</span>

          <span className={styles.sliderValContainer}>
            {unit && unitSide === 'left' && (
              <div className={styles.sliderValUnit}>
                <span>{unit}</span>
              </div>
            )}
            {editable ? (
              <input
                contentEditable
                onKeyPress={handleKeyPress}
                onBlur={handleBlur}
                className={styles.sliderValInput}
                type="number"
                min={String(min)}
                max={String(max)}
                step={String(step)}
                ref={inputRef}
                value={value}
                onChange={(e) => onChange(Number(e.currentTarget.value))}
              />
            ) : (
              <div className={styles.sliderVal}>{value}</div>
            )}
            {unit && unitSide === 'right' && (
              <div className={styles.sliderValUnit}>
                <span>{unit}</span>
              </div>
            )}
          </span>
        </label>
      )}

      <input
        type="range"
        id={id}
        value={value}
        min={String(min)}
        max={String(max)}
        step={String(step)}
        onChange={(e) => onChange(Number(e.currentTarget.value))}
        className={className}
      />
    </article>
  );
};

export default RangeInput;
